import { DomSanitizer } from '@angular/platform-browser';
import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeHtml',
  standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
  private sanitized = inject(DomSanitizer);

  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
